if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */
    
    // Slick Slider with current slide number
    $('.js-slick_carousel').each((i, el) => {
        let curLabel;

        $(el).on('init', (e, s)=> {
            curLabel = (`0${(s.currentSlide+1)}`).slice(-2) + '. ' + $('.slick-slide.slick-current',el).data('label');
            if ( s.options.dots ) {
                $(s.options.appendDots).append(`<span class="slick-current_label">${curLabel}</span>`);
            }
            console.log(s.currentSlide);
        });

        $(el).on('beforeChange', (e, s, c, n)=> {
            curLabel = (`0${(n+1)}`).slice(-2) + '. ' + $(s.$slides.get(n)).data('label');
            if ( s.options.dots ) {
                $('.slick-current_label',el).text(curLabel);
            }
        });

        $(el).slick();
    });

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });
    // $('.acc-btn').click(function(e){
    //     e.preventDefault();
    //    if($(this).hasClass('active')){
    //     $(this).removeClass("active");
    //     $(this).next().slideToggle();
    //    }else{
    //     $(".acc-btn").removeClass("active");
    //     $(".tab-content").slideUp();
    //     $(this).addClass('active');
    //     $(this).next().slideToggle();
    //    }
    // });

})();